module.exports = __webpack_public_path__ + "img/HU.d7683414.svg";